import { useState, useEffect, useCallback } from 'react';
import { Category } from '../types';
import ProductService from '../services/product-service';
import HttpClientRequest from '../api/client-request';

export const useCategories = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);


  const requestId = new Date().getTime().toString();

  const fetchCategories = useCallback(async () => {

    try {
      
      setLoading(true);
      const fetchedCategory =  await ProductService.getCategories(requestId);
      setCategories(fetchedCategory);
      
    } catch (error) {
      setError('Failed to fetch products');
    }
    finally {
      setLoading(false);
    }

  }, [requestId])

  useEffect(() => {

    void fetchCategories();

    return () => {
      
      HttpClientRequest.cancelRequest(requestId); // Cancel the request if needed

      setCategories([]);
      setLoading(false);
      setError(null);
    }
  }, []);

  return { categories, loading, error };
};